import { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface InfoTooltipSection {
  key: string;
  title?: string;
  items: InfoTooltipItem[];
}

export interface InfoTooltipItem {
  key: string;
  label: string;
  value: ReactNode;
  className?: string;
}

interface InfoTooltipContentProps {
  title?: string;
  titleIcon?: ReactNode;
  sections: InfoTooltipSection[];
  footer?: ReactNode;
  className?: string;
}

export const InfoTooltipContent = ({
  title,
  titleIcon,
  sections,
  footer,
  className,
}: InfoTooltipContentProps) => (
  <div className={cn("space-y-3", className)}>
    {title && (
      <div className="flex items-center gap-2">
        {titleIcon}
        <span className="font-semibold text-gray-900">{title}</span>
      </div>
    )}

    {sections.map((section, sectionIndex) => (
      <div key={section.key} className="space-y-1.5">
        {section.title && (
          <span className="text-xs font-medium text-gray-500">{section.title}</span>
        )}
        <div className="space-y-1 text-sm">
          {section.items.map(item => (
            <div key={item.key} className="flex justify-between gap-4">
              <span className="text-gray-600">{item.label}</span>
              <span className={cn("text-gray-900", item.className)}>{item.value}</span>
            </div>
          ))}
        </div>
        {sectionIndex < sections.length - 1 && <hr className="mt-2 border-gray-200" />}
      </div>
    ))}

    {footer && <div className="pt-1 text-xs text-gray-500">{footer}</div>}
  </div>
);
